module.exports = __webpack_public_path__ + "img/Main_grid_square_5.2b03936a.png";